import React from "react";
import FinishButton from "../FinishButton/FinishButton";

function Step6() {
  return (
    <div className="mm-finish">
      <div className="mm-pause-logo-wrapper">
        <img
          src={process.env.PUBLIC_URL + "/img/star.svg"}
          alt=""
          className="mm-pause-logo-star"
        />
        <img
          src={process.env.PUBLIC_URL + "/img/clock.svg"}
          alt=""
          className="mm-pause-logo-clock"
        />
      </div>
      <div className="mm-finish__text1">
        Регистрация на новый набор конкурса скоро откроется
      </div>
      <a href="/">
        <FinishButton className="mm-finish__tg" text="вернуться на главную" />
      </a>
    </div>
  );
}

export default Step6;
